import PropTypes from "prop-types";
import styles from "./ViewTransaction.module.css";
import store from "../../../Store/Store";
import { useEffect, useState, Fragment } from "react";
import config from "../../../config/config";
import axios from "axios";

const ViewTransaction = ({
  isVisible,
  onClose,
  openImg,
  closeImg,
  setimg,
  setName,
  className = "",
}) => {
  const [data, setData] = useState([]);
  const [openPopUp, setOpenPopUp] = useState(false);
  const [RequestingReject, setRequestingReject] = useState(false);
  const [RequestSend, setRequestSend] = useState(false);
  const [ApprovalStatus, setApprovalStatus] = useState("");

  useEffect(() => {
    if (isVisible) {
      console.log("getRecipts has been hit");

      let tokens = localStorage.getItem("authToken");
      let parsedTokens = JSON.parse(tokens);
      const obj = {
        ledger_label: store.Company_Id,
        payout_ref: store.txnId,
        // payout_ref: "20250122183151CUPI8119914818",
      };
      let payload = {
        method: "post",
        maxBodyLength: Infinity,
        url: `${config.node_api_endpoint}/cupi/admin/get_transaction_receipts`,
        headers: {
          aws_cognito_id_token: parsedTokens.IdToken,
          aws_cognito_access_token: parsedTokens.AccessToken,
          "Content-Type": "application/json",
        },
        data: obj,
      };

      axios
        .request(payload)
        .then((res) => {
          console.log("Data----->", res.data.data);
          setData(res.data.data);
          // setData()
        })
        .catch((er) => {
          console.log("error-->", er);
        });
    }
  }, [isVisible]);

  const handleDownload = async (url, name) => {
    try {
      setimg(url);
      setName(name);
      openImg();
    } catch (error) {
      console.error("Error downloading the image:", error);
    }
  };

  const getStatusConfig = (TxnStatus, status) => {
    const isProcessed = status === "processed";

    switch (TxnStatus) {
      case "Approved":
        return isProcessed
          ? {
              text: "SPEND APPROVED",
              image: "/Check_Icon.svg",
              className: styles.dataApproved,
            }
          : {
              text: "NA",
              image: "/na.svg",
              className: styles.dataNA,
            };
      case "NotSubmitted":
        return {
          text: "YET TO SUBMIT BILL",
          image: "/not-submitted.svg",
          className: styles.dataNotSubmitted,
        };
      case "Rejected":
        return {
          text: "SPEND REJECTED",
          image: "/X-Icon.svg",
          className: styles.dataRejected,
        };
      case "BillSubmitted":
        return {
          text: "BILL SUBMITTED",
          image: "/hourGlass-icon.svg",
          className: styles.dataBillSubmitted,
        };
      case "Resubmit":
        return {
          text: "RESUBMIT BILL",
          image: "/refresh.svg",
          className: styles.dataResubmit,
        };
      default:
        return {
          text: "NA",
          image: "/na.svg",
          className: styles.dataNA,
        };
    }
  };

  const renderStatus = (txnStatus, status, index) => {
    let newStatus =
      index == 1
        ? "NotSubmitted"
        : index == 2
        ? "Rejected"
        : index == 3
        ? "BillSubmitted"
        : index == 9
        ? "Resubmit"
        : txnStatus;
    const { text, image, className } = getStatusConfig(newStatus, status);

    return (
      <div className={className}>
        {text != "NotSubmitted" && text != "NA" && status === "processed" && (
          <img alt={text} src={image} className={styles.btn_img} />
        )}
        <span>{text}</span>
      </div>
    );
  };

  const ApproveTransactions = () => {
    onClose();
    closeImg();
  };

  const RejectTransactions = (reason) => {
    setOpenPopUp(true);
    console.log("RequestingReject", RequestingReject);
    if (reason == "reject") {
      console.log("RequestingReject", RequestingReject);

      setRequestingReject(true);
    } else {
      console.log("RequestingReject", RequestingReject);
      setRequestingReject(false);
    }
  };

  const HandleTxnReject = async (status) => {
    if (status) {
      //RejectSpend
      setOpenPopUp(false);
      return;
    } else {
      //RequestResubmit
      setRequestSend(true);
      await new Promise((resolve) => setTimeout(resolve, 5000));
      setOpenPopUp(false);
    }
  };

  useEffect(() => {
    setApprovalStatus(store.txnStatus);
  }, []);
  if (!isVisible) return null;
  return (
    <Fragment>
      <div
        className={[styles.frameParent, className].join(" ")}
        onClick={(e) => {
          e.stopPropagation();
        }}
      >
        <div
          className={styles.xCloseWrapper}
          onClick={() => {
            store.setDate("");
            store.setPaidTo("");
            store.setPurpose("");
            store.setDebit("");
            store.setUPIId();
            store.setUtr("");
            store.setTxnId("");
            onClose();
            closeImg();
          }}
        >
          <img className={styles.xCloseIcon} alt="" src="/xclose.svg" />
        </div>
        <div className={styles.frameGroup}>
          <div className={styles.transactionDetailsParent}>
            <div className={styles.transactionDetailshead}>
              Transaction details
            </div>
            <div className={styles.frameContainer}>
              <div className={styles.dateParent}>
                <div className={styles.transactionContainer}>
                  <div className={styles.date}>DATE</div>
                  <div className={styles.transactionDetails}>
                    {store?.date || "-"}
                  </div>
                </div>
                <div className={styles.transactionContainer}>
                  <div className={styles.date}>PURPOSE</div>
                  <div className={styles.transactionDetails}>
                    {store?.purpose == "N/A" || store?.purpose == "Expense"
                      ? "N/A"
                      : store?.purpose || "-"}
                  </div>
                </div>
                <div className={styles.transactionContainer}>
                  <div className={styles.date}>AMOUNT PAID</div>
                  <div className={styles.transactionDetails}>
                    ₹{store?.debit || "-"}
                  </div>
                </div>
                <div className={styles.transactionContainer}>
                  <div className={styles.date}>PAID TO</div>
                  <div className={styles.transactionDetails}>
                    {store?.paidTo || "-"}
                  </div>
                </div>
                <div className={styles.transactionContainer}>
                  <div className={styles.date}>UPI ID</div>
                  <div className={styles.transactionDetails}>
                    {store?.UPI_id || "-"}
                  </div>
                </div>
                <div className={styles.transactionContainer}>
                  <div className={styles.date}>UTR/RRN</div>
                  <div className={styles.transactionDetails}>
                    {store?.utr || "-"}
                  </div>
                </div>
                <div className={styles.transactionContainer}>
                  <div className={styles.date}>TXN ID</div>
                  <div className={styles.transactionDetails}>
                    {store?.txnId || "-"}
                  </div>
                </div>

                <div className={styles.transactionContainer}>
                  <div className={styles.date}>CATEGORY</div>
                  <div className={styles.transactionDetails}>
                    {store?.category || "-"}
                  </div>
                </div>
                <div className={styles.transactionContainer}>
                  <div className={styles.date}>TXN STATUS</div>
                  <div
                    className={
                      store?.status == "processed"
                        ? styles.transactionDetailsProcessed
                        : store?.status == "initiating"
                        ? styles.transactionDetailsPENDING
                        : styles.transactionDetailsFAILED
                    }
                  >
                    {store?.status == "processed"
                      ? "PAYMENT PROCESSED"
                      : store?.status == "initiating"
                      ? "PAYMENT PROCESSING"
                      : "PAYMENT REVERSED" || "-"}
                  </div>
                </div>

                {false && (
                  <div className={styles.transactionContainer}>
                    <div className={styles.date}>APPROVAL STATUS</div>
                    <div className={styles.transactionDetails}>
                      {renderStatus(store.txnStatus, store.status, store.index)}
                    </div>
                  </div>
                )}
                <div className={styles.date}></div>
              </div>
            </div>
          </div>
          <div className={styles.frameBorder}></div>
          <div className={styles.frameWrapper}>
            {data.length > 0 ? (
              <div className={styles.attachmentParent}>
                <div className={styles.attachment}>Bill Attachment</div>
                <div className={styles.img202410288948Parent}>
                  {data.map((detail, index) => {
                    let name = `${store.txnId}${detail.image_name}`;
                    return (
                      <div className={styles.container} key={index}>
                        <div className={styles.img202410288948}>
                          <img
                            className={styles.xCloseIcon1}
                            alt=""
                            src="/ImagePlaceholder.svg"
                          />
                          <div className={styles.imageName}>
                            {`${name.slice(0, 23)}(${index + 1})`}
                          </div>
                        </div>
                        <button
                          className={styles.img202410288949}
                          onClick={() => handleDownload(detail.url, name)}
                        >
                          View
                        </button>
                      </div>
                    );
                  })}
                </div>
              </div>
            ) : (
              <div className={styles.attachmentParent1}>
                <div className={styles.attachment}>Bill Attachment</div>
                <div className={styles.imgParent202410288948}>NA</div>
              </div>
            )}
          </div>
          {/* Resubmit */}
          {ApprovalStatus == "Resubmit" && (
            <div className={styles.ResubmitReasonContainer}>
              <div className={styles.ResubmitReasonHeading}>
                Reason for requesting the bill.
              </div>
              <div className={styles.ResubmitReasonReason}>
                Image quality is not clear up Image quality is not clear up
                Image quality is not clear.
              </div>
            </div>
          )}
          {data.length > 0 &&
            false &&
            ApprovalStatus != "Approved" &&
            ApprovalStatus != "Rejected" && (
              <div className={styles.Buttons}>
                {ApprovalStatus != "Resubmit" && (
                  <button
                    className={styles.RequestResubmitSendButtons}
                    onClick={() => {
                      RejectTransactions();
                    }}
                  >
                    <img
                      className={styles.xCloseIcon31}
                      alt=""
                      src="/ResubmitIcon.svg"
                    />
                    Request Bill
                  </button>
                )}
                <button
                  className={styles.RejectSendButtons}
                  onClick={() => {
                    RejectTransactions("reject");
                  }}
                >
                  <img
                    className={styles.xCloseIcon3}
                    alt=""
                    src="/X-Blue-Icon.svg"
                  />
                  Reject Spend
                </button>
                <button
                  className={styles.ApproveSendButtons}
                  onClick={() => {
                    ApproveTransactions();
                  }}
                >
                  <img
                    className={styles.xCloseIcon3}
                    alt=""
                    src="/white-check-Icon.svg"
                  />
                  Approve Spend
                </button>
              </div>
            )}
        {store.userType == "PineLabUser" && (
          <div className={styles.finalCupiLogo}>
            <img className={styles.escrowLogo} alt="" src="/PineLabsLogo.svg" />
          </div>
        )}
        </div>

      </div>
      {openPopUp && (
        <div className={styles.overlay}>
          <div
            className={styles.RejectCard}
            onClick={(e) => {
              e.stopPropagation();
            }}
          >
            <div className={styles.RejectCardQuestion}>
              {RequestingReject
                ? "Are you sure you want to reject this transaction?"
                : "Please mention the reason for requesting the bill."}
            </div>
            <div className={styles.Container}>
              <textarea
                className={styles.TextArea}
                placeHolder={
                  RequestingReject
                    ? "Write reason for rejection..."
                    : "Write reason for requesting resubmit..."
                }
              />
              {RequestingReject && (
                <div className={styles.ContainerWarning}>
                  <img
                    className={styles.ContainerWarningIcon}
                    alt=""
                    src="/Exclamation-orange-icon.svg"
                  />
                  This action can’t be undone. If needed, you can always request
                  the user to resubmit the bills.
                </div>
              )}
              <div className={styles.ButtonsContainer}>
                <button
                  className={styles.ContainerButtonCancel}
                  onClick={() => {
                    setOpenPopUp(false);
                  }}
                >
                  Cancel
                </button>
                <button
                  className={styles.ContainerButton}
                  onClick={() => {
                    HandleTxnReject(RequestingReject);
                  }}
                >
                  Submit
                </button>
              </div>
              {RequestSend && !RequestingReject && (
                <div className={styles.BottomDiv}>
                  <div className={styles.RequestSentProp}>
                    <img
                      className={styles.xCloseIcon32}
                      alt=""
                      src="/check-circle.svg"
                    />
                    Request Sent
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      )}
    </Fragment>
  );
};

ViewTransaction.propTypes = {
  className: PropTypes.string,
};

export default ViewTransaction;
